import React, { useContext, useState } from 'react';
import {
  Avatar,
  Box,
  Button,
  Container,
  CssBaseline,
  TextField,
  Typography,
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { AuthContext } from './AuthContextProvider';

const Login = (props) => {
  const [mobilePhone, setMobilePhone] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const { login: contextLogIn } = useContext(AuthContext);

  const login = (event) => {
    event.preventDefault();
    if (mobilePhone.length === 0) {
      setErrorMessage('Please enter the mobile number to login.');
    } else {
      contextLogIn(mobilePhone)
        .then(({users, message }) => props.history.push('/verify',{ users, message }))
        .catch((err) => setErrorMessage(err.message))
    }
  };

  const mobileNumberChange = (e) => {
    setErrorMessage('');
    setMobilePhone(e.target.value);
  };

  const onPressEnter = (e) => {
    if (e.charCode === 13) {
      login(e);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: '#1565c0' }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>
        <Box component="form" sx={{ mt: 1 }} onSubmit={login}>
          <TextField
            margin="normal"
            required
            error={errorMessage.length > 0}
            fullWidth
            id="mobileNumber"
            label="Mobile Number"
            name="mobileNumber"
            autoFocus
            autoComplete="off"
            value={mobilePhone}
            inputProps={{ inputMode: 'numeric' }}
            onChange={mobileNumberChange}
            onKeyPress={onPressEnter}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Sign In
          </Button>
        </Box>
        <Typography
          style={{ color: 'red' }}
          variant="body2"
          display="block"
          gutterBottom
        >
          {errorMessage}
        </Typography>
      </Box>
    </Container>
  );
};

export { Login };
